import { getAuthenticatorSelectedChannel } from '../../../utils/widget-facade';
import OktaVerifyEnrollBaseCustomizer from '../base';

export default class EnrollPollBaseCustomizer extends OktaVerifyEnrollBaseCustomizer {
  protected selectedChannel = getAuthenticatorSelectedChannel();
  async shouldCustomize() {
    return (await super.shouldCustomize()) && this.context.formName === 'enroll-poll';
  }
}
